<template>
  <div class="">
    <h2>Click Generate new keys. Hang tight.</h2>
    <div
      v-if="loading"
      class="row d-flex justify-content-center align-middle my-4"
    >
      <h3>Loading magical things :)</h3>
    </div>
    <div
      v-if="noDataFound"
      class="row d-flex justify-content-center align-middle my-4"
    >
      <h3>There are no installed keys on this environment.</h3>
    </div>
    <VueyeTable
      :data="rows"
      :columns="columns"
      title="Keys"
      filter-by="vehicle_id"
      v-show="rows.length"
    >
      <template v-slot:key_info_id="{ item }">
        <b>{{ item.key_info_id }}</b>
      </template>
      <template v-slot:vehicle_id="{ item }">
        <strong>{{ item.vehicle_id }}</strong>
      </template>
      <template v-slot:ownership="{ item }">
        <strong>{{ item.ownership }}</strong>
      </template>
      <template v-slot:oem="{ item }">
        <strong>{{ item.oem }}</strong>
      </template>
      <template v-slot:state="{ item }">
        <strong>{{ item.state }}</strong>
      </template>
      <template v-slot:actions="{ item }">
        <div class="ve-table-actions">
          <!-- <button class="ve-table-btn ve-table-btn-primary" @click="edit(item)">Edit</button> -->
          <button
            class="ve-table-btn ve-table-btn-danger"
            @click="deleteItem(item)"
          >
            Delete Key
          </button>
        </div>
      </template>
    </VueyeTable>
    <div class="container">
      <label class="message" for="selected">Select an environment</label>
      <select
        class="form-select my-2"
        aria-label="Select an environment"
        v-model="selected"
      >
        <option selected>Select an environment</option>
        <option value="qa">QA</option>
        <!-- <option value="stg">STG</option>
        <option value="stgOne">STG ONE</option> -->
        <option value="stgTwo">STG</option>
        <option value="prod">PROD</option>
        <!-- <option value="prod1607">PROD1607 and 9</option> -->
      </select>
    </div>
    <div class="py-3" style="text-align: center">
      <button class="ty-button" v-on:click="getKeys">Request Keys</button>
    </div>
  </div>
</template>

<script>
import VueyeTable from "vueye-table";

export default {
  name: "dkkeys",
  data: () => ({
    keys: null,
    error: null,
    loading: false,
    qaURL: "https://gvw9p1ejk4.execute-api.us-west-2.amazonaws.com/dev/dkinfo",
    stgURL:
      "https://g58qoi07i9.execute-api.us-west-2.amazonaws.com/staging/dkinfo",
    stgOneURL:
      "https://0optl75mw9.execute-api.us-west-2.amazonaws.com/staging/dkinfostgone",
    stgTwoURL:
      "https://iawtvi82bi.execute-api.us-west-2.amazonaws.com/staging/dkinfostgtwob",
    prodURL:
      "https://ojjp1mt3ef.execute-api.us-west-2.amazonaws.com/staging/dkinfo",
    prod1607URL:
      "https://vgpzo61qri.execute-api.us-west-2.amazonaws.com/staging/dkinfowone",
    selected: "prod",
    columns: [
      {
        label: "KeyInfo ID",
        key: "key_info_id",
        display: true,
        sortable: true,
      },
      {
        label: "Vehicle ID",
        key: "vehicle_id",
        display: true,
        sortable: true,
      },
      {
        label: "Ownership",
        key: "ownership",
        display: true,
        sortable: true,
      },
      {
        label: "State",
        key: "state",
        display: true,
        sortable: true,
      },
      {
        label: "OEM",
        key: "oem",
        display: true,
        sortable: true,
      },
      {
        key: "actions",
        label: "Actions",
        sortable: false,
        display: true,
      },
    ],
    rows: [],
  }),
  components: {
    VueyeTable,
  },
  methods: {
    generateENVURL: function () {
      if (this.selected === "stg") {
        return this.stgURL;
      }
      if (this.selected === "stgOne") {
        return this.stgOneURL;
      }
      if (this.selected === "stgTwo") {
        return this.stgTwoURL;
      }
      if (this.selected === "prod") {
        return this.prodURL;
      }
      if (this.selected === "prod1607") {
        return this.prod1607URL;
      } else {
        return this.qaURL;
      }
    },
    getKeys: async function () {
      console.log("Selected Environment: ", this.generateENVURL());
      const ENV_URL = this.generateENVURL();
      this.keys = null;
      this.error = null;
      this.loading = true;
      this.noDataFound = false;
      const config = {
        method: "get",
        url: ENV_URL,
      };

      this.axios(config)
        .then((response) => {
          this.loading = false;
          this.noDataFound = false;
          // eslint-disable-next-line no-console
          console.log("response: ", response.data.results);
          if (response.data.results.length < 1) {
            this.noDataFound = true;
          }
          this.rows = response.data.results.rows;
        })
        .catch((error) => {
          this.loading = false;
          this.error = error;
        });
    },
    deleteItem: function (item) {
      console.log("delete key called.");
      const foundItem = this.rows.find(
        (row) => row.key_info_id === item.key_info_id
      );
      if (foundItem.state !== "INSTALLED") {
        alert("This key doesn't need to be uninstalled");
        return;
      }
      if (foundItem.state === "INSTALLED") {
        const ENV_URL = this.generateENVURL();
        const config = {
          method: "delete",
          url: ENV_URL,
          data: {
            keyID: `${foundItem.key_info_id}`,
          },
        };

        this.axios(config)
          .then((response) => {
            // eslint-disable-next-line no-console
            console.log("response: ", response.data.results);
            alert(
              "This key is marked for deletion, please Get New Keys to verify."
            );
          })
          .catch(() => {
            alert("That didn't go so well.  Sorry about that.");
          });
      }
    },
  },
};
</script>

<style scoped>
body {
  font-family: ToyotaType-Regular, sans-serif;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.ty-button {
  background: #d92429;
  border-radius: 0px;
  width: 320px;
  height: 56px;
  font-family: ToyotaType-Semibold;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0.73px;
  text-align: center;
}

.qr-container {
  padding-top: 40px;
  text-align: center;
  height: 300px;
  /*background-color: #4281ff;*/
  height: 540px;
}
</style>
